import { IAttribute, IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format, getConnectorLegacyNameByFlag } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

export const googleBigQueryAuthTypes = {
    UserAuthentication: 'UserAuthentication',
    ServiceAuthentication: 'ServiceAuthentication'
};

@Metamodel.model({
    name: adfModelTypeMap.googleBigQuery.linkedServiceType,
    disabled: __IS_FABRIC_DPE__,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, getConnectorLegacyNameByFlag(stringResources.GoogleBigQuery_DisplayText, true)),
        format(stringResources.ModelName_LinkedServicesTemplate, getConnectorLegacyNameByFlag(stringResources.GoogleBigQuery_DisplayText, true))
    ]
})
export class GoogleBigQueryLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public static readonly PROJECT_ID: IAttribute;
    public static readonly ADDITIONAL_PROJECTS: IAttribute;
    public static readonly REQUEST_GOOGLE_DRIVE_SCOPE: IAttribute;
    public static readonly CLIENT_ID: IAttribute;
    public static readonly CLIENT_SECRET: IAttribute;
    public static readonly REFRESH_TOKEN: IAttribute;
    public static readonly EMAIL: IAttribute;
    public static readonly KEY_FILE_PATH: IAttribute;
    public static readonly TRUSTED_CERT_PATH: IAttribute;
    public static readonly USE_SYSTEM_TRUST_STORE: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_ProjectID,
        association: 'PROJECT_ID',
        templatable: true
    })
    public project?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AdditionalProjectIDs,
        association: 'ADDITIONAL_PROJECTS',
        templatable: true
    })
    public additionalProjects?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_RequestGoogleDriveScope,
        association: 'REQUEST_GOOGLE_DRIVE_SCOPE',
        templatable: true
    })
    public requestGoogleDriveScope?: boolean = false;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientId,
        association: 'CLIENT_ID',
        templatable: true
    })
    public clientId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientSecret,
        association: 'CLIENT_SECRET',
        templatable: true,
        accepts: ['String'],
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public clientSecret?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_RefreshToken,
        association: 'REFRESH_TOKEN',
        templatable: true,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        accepts: ['String']
    })
    public refreshToken?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.EmailLabel,
        association: 'EMAIL',
        templatable: true
    })
    public email?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_KeyFilePath,
        association: 'KEY_FILE_PATH',
        templatable: true
    })
    public keyFilePath?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_TrustedCertPath,
        association: 'TRUSTED_CERT_PATH',
        templatable: true,
    })
    public trustedCertPath?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseSystemTrustStore,
        association: 'USE_SYSTEM_TRUST_STORE',
        templatable: true
    })
    public useSystemTrustStore?: boolean = false;

    public override  isLegacyConnector = true;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
